<template>
  <div class="wrapper">
    <div class="main">
      <div class="logo">
        <img :src="imgHost + 'logo_bg1.png'" />
      </div>
      <div class="item1" @click="scanCode">
        <img
          class="icon"
          src="http://assets.rurushishi.com/activies/caseCode/icon1.png"
        />
        <div class="submit">扫码核销</div>
      </div>
      <div class="name">
        <input
          type="text"
          placeholder="请输入核销码"
          @blur="blurInput"
          v-model="prizeCode"
        />
        <!-- <div class="submit" @click="query">查 询</div> -->
        <div class="submit" @click="submit">核 销</div>
      </div>
      <!-- 弹窗 -->
      <div class="masks" v-show="showPrize">
        <!-- <div :style="{height: scrollTop}"></div> -->
        <div class="info">
          <div class="title">奖品详情</div>
          <div class="item">
            奖品名称:{{ detail.orderName || detail.prizeName }}
          </div>
          <!-- <div class="item">奖品描述:{{detail.orderDetail}} </div> -->
          <!-- <div class="item">手机号:{{detail.mobile}} </div> -->
          <div class="item">
            领奖地址:{{
              detail.expandParams
                ? detail.expandParams.addressName
                : detail.address
            }}
          </div>
          <div class="item">
            状态:{{ detail.status === 3 ? "未核销" : "已核销" }}
          </div>
          <span class="sclose" @click="showPrize = false">
            <img
              src="http://assets.rurushishi.com/activies/panda-game/close.png"
              alt
            />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let that = null;
import { MessageBox } from "mint-ui";
export default {
  data() {
    return {
      prizeCode: "",
      infoId: this.$config.infoId,
      isClick: false,
      showPrize: false,
      detail: {},
    };
  },
  components: {},
  methods: {
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      console.log(this.windowHeight + "--" + windowFocusHeight);
      console.log("修复");
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      that.temporaryRepair();
    },
    // query() {
    //   if (!this.isClick) {
    //     this.isClick = true;
    //     if (!this.prizeCode) {
    //       return MessageBox.alert("请先输入核销码", "提示");
    //     }
    //     this.prizeCode = this.prizeCode.toLowerCase();
    //     let url = `/act-data/prizeWriteOff/prize/writeOff`;
    //     this.$httpdf
    //       .get(
    //         url,
    //         {
    //           actId: this.$config.actId,
    //           prizeCode: this.prizeCode,
    //         },
    //         {
    //           token: "b16f854daa550780339aea4a0eabab08",
    //         }
    //       )
    //       .then((data) => {
    //         if (data.code == 0) {
    //           console.log(data);
    //           this.showPrize = true;
    //           this.isClick = false;
    //           // data.data.expandParams = JSON.parse(data.data.expandParams)
    //           this.detail = data.data;
    //         } else {
    //           MessageBox.alert(data.msg);
    //           this.isClick = false;
    //         }
    //       });
    //   }
    // },
    submit() {
      if (!this.isClick) {
        this.isClick = true;
        if (!this.prizeCode) {
          return MessageBox.alert("请先输入核销码", "提示");
        }
        this.prizeCode = this.prizeCode.toLowerCase();
        let url = `/act-data/prizeWriteOff/prize/writeOff`;
        this.$httpdf
          .post(
            url,
            {
              prizeCode: this.prizeCode,
              appId: this.$config.APPID,
              // openId: "oHbpVwdkI9BNq--BfVwGLmAkVRFM",
              writeOffName: this.$userInfo.nickName,
              writeOffOpenId: this.$openid,
            },
            {
              token: "b16f854daa550780339aea4a0eabab08 ",
            }
          )
          .then((data) => {
            if (data.code == 0) {
              return MessageBox.alert(
                `兑换成功！`,
                "提示"
              ).then(() => {
                this.isClick = false;
              });
            } else {
              return MessageBox.alert(data.msg, "提示").then(() => {
                this.isClick = false;
              });
            }
          });
      }
    },
    scanCode() {
      console.log("调用前");
      this.$wx.ready(() => {
        console.log("调用后");
        this.$wx.scanQRCode().then((res) => {
          let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          console.log(res.resultStr,'555');
          //res.resultStr json字符串转json对象
          console.log(JSON.parse(result).prizeCode,'777');
          this.prizeCode = JSON.parse(result).prizeCode;
          console.log("执行前");
          this.getPrizeInfo();
          console.log("执行后");
        });
      });
    },
    getPrizeInfo() {
      let _self = this;
      console.log(_self.prizeCode,'888')
      _self.prizeCode = _self.prizeCode.toLowerCase();
      console.log(_self.prizeCode,'9991')
        // .toLowerCase()
        // .replace(/(^\s*)|(\s*$)/g, "");
      let url = `/act-data/prizeWriteOff/prize/writeOff`;

      this.$httpdf
        .post(
          url,
          {
            prizeCode: _self.prizeCode,
            appId: this.$config.APPID,
            writeOffName: this.$userInfo.nickName,
            writeOffOpenId: this.$openid,
          },
          {
            token: "b16f854daa550780339aea4a0eabab08 ",
          }
        )
        .then((data) => {
          if (data.code == 0) {
            if (!data.data) {
              return MessageBox.alert("兑奖码无效").then(() => {
                _self.isClick = false;
              });
            } else {
              return MessageBox.alert(
                `兑换成功！`,
                "提示"
              ).then(() => {
                _self.isClick = false;
              });
            }
          } else {
            _self.isClick = false;
            _self.$showModal(data.msg || "网络错误,请重试!");
            return MessageBox.alert(data.msg, "提示").then(() => {
              _self.isClick = false;
              });
          }
        });
    },
  },
  created() {
    that = this;
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: url($imgHost + "bg.jpg?t=5") 0 0 / 100% repeat-y;
  min-height: 100vh;
}

.main {
  min-height: 100vh;
  width: 100%;
  // background-image: url('http://assets.rurushishi.com/activies/zy-purchase/bg.jpg?t=2');
  // background-size: 100% auto;
  // background-repeat: no-repeat;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
}

.name {
  height: 50px;
  width: 70%;
  background: #fff;
  border-radius: 25px;
  margin-top: 20px;
}

input {
  color: #333;
  width: 92%;
  padding-left: 6%;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  background-color: transparent;
  border: none;
}

input::-webkit-input-placeholder {
  color: #a9a9a9;
  font-size: 14px;
}

.submit {
  position: relative;
  margin: 25px auto;
  width: 140px;
  height: 37px;
  line-height: 37px;
  background: linear-gradient(0deg, #df922f, #ffd542);
  border-radius: 22px;
  font-family: PingFangSC;
  font-weight: 500;
  color: #fff;
  font-size: 18px;
  letter-spacing: 4px;
  margin-bottom: 15px;
  text-align: center;
}
// logo
.logo {
  padding-top: 20px;
  width: $logoWidth;
}
// slogan
.slogan {
  width: $sloganWidth;
  position: relative;
  z-index: 2;
  margin-top: 8px;
}

.masks {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .info {
    position: relative;
    width: 290px;
    background: #ffffff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;

    .title {
      font-size: 18px;
      color: #d80c18;
      font-family: PingFang SC;
      font-weight: bold;
      text-align: center;
      letter-spacing: 2px;
      margin-bottom: 20px;
    }

    .item {
      font-size: 12px;
      margin-bottom: 30px;
      line-height: 20px;
      width: 270px;
      // border-bottom: 1px solid #E9E9E9;
      align-items: center;
      color: #d80c18;
    }
  }

  .sclose {
    position: absolute;
    top: -40px;
    right: 0px;
    width: 20px;
    height: 20px;

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.item1 {
  position: relative;
  width: 343px;
  // height: 148px;
  // background: linear-gradient(180deg, #EEF6FF 0%, #FFFFFF 32.89%);
  // border: 1px solid #FFFFFF;
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: -42px auto 0;
  padding: 16px 2%;
  box-sizing: border-box;

  .icon {
    width: 64px;
  }

  // .submit {
  //   font-family: PingFang SC;
  //   font-style: normal;
  //   font-weight: normal;
  //   font-size: 14px;
  //   line-height: 24px;
  //   text-align: center;
  //   color: #fff;
  //   margin-top: 12px;
  // }
}
</style>